import React, { useState, useEffect, useMemo } from 'react';
import { Container, Card, Button, Form, InputGroup, Row, Col } from 'react-bootstrap';
import { FaBus, FaArrowRight, FaRupeeSign, FaUser, FaPhoneAlt, FaEnvelope, FaCalendarCheck, FaStickyNote, FaUsers, FaChevronDown } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import BASE_URL from '../../component/commanfile';

const TourBookingCard = ({ packages }) => {
  const [selectedType, setSelectedType] = useState(packages?.type === "fit" ? 'fit' : 'schedule' );
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateId, setSelectedDateId] = useState(null);
  const [selectedVehicleIdx, setSelectedVehicleIdx] = useState(0);
  const [selectedFitRateId, setSelectedFitRateId] = useState(null); 
  const [occupancy, setOccupancy] = useState('doubleOccupancy');
  console.log("selectedDate:",packages);
   const [formErrors, setFormErrors] = useState({}); // NEW state for errors
  

  const [formData, setFormData] = useState({
    name: '', mobile: '', email: '', customerNotes: '', adults: 0, children: 0
  });

  const validSchedules = useMemo(() => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return packages?.tourSchedule?.filter(batch => {
      const d = new Date(batch.startDate);
      return d >= today;
    }) || [];
  }, [packages]);

  const enabledDates = useMemo(() => validSchedules.map(s => new Date(s.startDate)), [validSchedules]);
  const activeBatch = validSchedules.find(b => b.id === selectedDateId) || {};

  // AUTO-SELECT FIRST RATE WHEN VEHICLE CHANGES
  useEffect(() => {
    if (selectedType === 'fit' && packages?.forfit?.[selectedVehicleIdx]) {
      const firstRate = packages.forfit[selectedVehicleIdx].seatConfigurationRate?.[0];
      if (firstRate) setSelectedFitRateId(firstRate.id);
    }
  }, [selectedType, selectedVehicleIdx, packages]);

  // NEW LOGIC: When Pax is selected, update Adult count automatically
  useEffect(() => {
    if (selectedType === 'fit' && selectedFitRateId) {
      const currentVehicle = packages?.forfit?.[selectedVehicleIdx];
      const activeRate = currentVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);
      
      if (activeRate) {
        setFormData(prev => ({
          ...prev,
          adults: parseInt(activeRate.numberOfPerson) || 1,
          children: 0 // Reset children to 0 when a new pax bracket is chosen
        }));
      }
    }
  }, [selectedFitRateId, selectedType, selectedVehicleIdx, packages]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    const match = validSchedules.find(s => new Date(s.startDate).toDateString() === date.toDateString());
    if (match) setSelectedDateId(match.id);
  };

  const calculateTotal = () => {
    if (selectedType === 'fit') {
      const currentFitVehicle = packages?.forfit?.[selectedVehicleIdx];
      const activeRate = currentFitVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);
      return parseFloat(activeRate?.price || 0) * (formData.adults + formData.children);
    }
    return parseFloat(activeBatch[occupancy] || 0) * (formData.adults + formData.children);
  };

  const styles = {
    card: { border: 'none', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', background: '#fff' },
    header: { background: '#0a3b78', color: '#fff', padding: '15px', textAlign: 'center', fontWeight: 'bold' },
    vehicleTile: (active) => ({
      cursor: 'pointer', padding: '12px', borderRadius: '12px',
      border: active ? '2px solid #0a3b78' : '1px solid #dee2e6',
      backgroundColor: active ? '#f0f7ff' : '#fff',
      textAlign: 'center', minWidth: '140px', transition: '0.3s'
    }),
    paxBadge: (active) => ({
      cursor: 'pointer', padding: '8px 15px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
      border: active ? '1px solid #0a3b78' : '1px solid #dee2e6',
      backgroundColor: active ? '#0a3b78' : '#fff',
      color: active ? '#fff' : '#666', transition: '0.2s'
    }),
    dateBox: { background: '#eef6ff', border: '1px solid #0a3b78', borderRadius: '8px', padding: '12px', color: '#0a3b78', fontWeight: '600', marginTop: '15px', textAlign: 'center' }
  };

    const validateForm = () => {
    const errors = {};

    // Name check
    if (!formData.name.trim()) errors.name = "Name is required";

    // Mobile check
    if (!formData.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      errors.mobile = "Enter a valid 10-digit mobile number";
    }

    // Email check
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = "Enter a valid email address";
    }

 

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBookingSubmit = async () => {
    if (!validateForm()) return; // Stop submission if invalid

    const isFit = selectedType === 'fit';
    const activeVehicle = isFit ? packages?.forfit[selectedVehicleIdx] : null;
    const activeFitRate = activeVehicle?.seatConfigurationRate?.find(r => r.id === selectedFitRateId);

    const payload = {
      name: formData.name,
      mobileNumber: formData.mobile,
      email: formData.email,
      type: packages?.type === "fit" ? "fit" : "package",
      selectedPackage: packages?.id || "",
      selectedSchedule: isFit ? "" : activeBatch?.id || "",
      customerNotes: formData.customerNotes,
      adults: formData.adults || 1,
      children: formData.children || 0,
      tentativeDate: isFit ? "" : activeBatch?.startDate || "",
      hotelCategory: isFit ? "" : occupancy,
      vehicle: isFit ? activeVehicle?.id : "",
      fitPackage: isFit ? activeFitRate?.id : "",
      tourFitFlag: isFit ? "true" : "false",
    };

    try {
      const res = await axios.post(`${BASE_URL}api/tourinquery`, payload);
      alert('Booking Request Sent Successfully!');
      setFormData({ name: '', mobile: '', email: '', customerNotes: '', adults: 1, children: 0 });
      setFormErrors({});
    } catch (err) {
      console.error("Booking Error:", err);
      alert('Failed to send booking request. Please try again.');
    }
  };
  return (
    <Container className="py-4">
      <style>{`
        .react-datepicker { border: none !important; width: 100%; display: flex; justify-content: center; }
        .available-start-date { background-color: #28a745 !important; color: white !important; border-radius: 50% !important; }
        .react-datepicker__day--selected { background-color: #0a3b78 !important; color: white !important; border-radius: 50% !important; }
     
     
     `}</style>

      <Card style={styles.card}>
        <div style={styles.header}>TOUR ENQUIRY & BOOKING</div>
        <Card.Body className="p-4" style={{ maxHeight: '80vh', overflowY: 'auto', overflowX: 'hidden' }}>
          
          {/* 1. VEHICLE & PAX SELECTION */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-uppercase text-muted small">1. Choose Your Vehicle</h6>
         
            <div className="d-flex gap-3 overflow-auto pb-2 mb-3">
         {packages.type != "fit" && (
              <div style={styles.vehicleTile(selectedType === 'schedule')} onClick={() => setSelectedType('schedule')}>
                <FaBus size={20} color={selectedType === 'schedule' ? '#0a3b78' : '#999'} className="mb-1" />
                <div className="fw-bold small">Group Tour Bus</div>
              </div>
         )}
              {packages?.forfit?.map((veh, index) => (
                <div key={veh.id || index} style={styles.vehicleTile(selectedType === 'fit' && selectedVehicleIdx === index)} onClick={() => { setSelectedType('fit'); setSelectedVehicleIdx(index); }}>
                  <FaBus size={20} color={selectedType === 'fit' && selectedVehicleIdx === index ? '#0a3b78' : '#999'} className="mb-1" />
                  <div className="fw-bold small text-truncate">{veh.vehicleName || veh.vihicalname || 'Private'}</div>
                </div>
              ))}
            </div>

            {selectedType === 'fit' && packages?.forfit?.[selectedVehicleIdx]?.seatConfigurationRate && (
              <div className="p-3 border rounded-3 bg-light">
                <label className="small fw-bold text-muted mb-2 d-block"><FaUsers className="me-1"/> Select Number of Persons</label>
                <div className="d-flex gap-2 flex-wrap">
                  {packages.forfit[selectedVehicleIdx].seatConfigurationRate.map((rate) => (
                    <div 
                      key={rate.id} 
                      style={styles.paxBadge(selectedFitRateId === rate.id)}
                      onClick={() => setSelectedFitRateId(rate.id)}
                    >
                      {rate.numberOfPerson} Pax
                    </div>
                  ))}
                </div>
              </div>
            )}
  {selectedType === 'schedule' && (
    <div className="p-3 border rounded-3 bg-light">
                <label className="small fw-bold text-muted mb-2 d-block"><FaUsers className="me-1"/> Select Occupancy</label>
                <div className="d-flex gap-2 flex-wrap">
                     <Form.Select  value={occupancy} onChange={e => setOccupancy(e.target.value)}>
                  <option value="doubleOccupancy">Double</option>
                  <option value="tripleOccupancy">Triple</option>
                </Form.Select>
                </div>
              </div>
            
              )}

          </div>

          {/* 2. CALENDAR */}
<div className="departure-selection mb-4">
  <div className="d-flex align-items-center mb-3">
    <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white me-2" style={{ width: '24px', height: '24px', fontSize: '12px' }}>2</div>
    <h6 className="fw-bold mb-0 text-uppercase text-secondary small">Select Departure Date</h6>
  </div>

  <div className="position-relative">
    <DatePicker
      selected={selectedDate}
      onChange={handleDateChange}
      // LOGIC: If FIT, allow all future dates. Otherwise, only show enabledDates.
      minDate={new Date()} 
      includeDates={packages?.type === "fit" ? undefined : enabledDates}
      
      placeholderText="Select your travel date"
      dateFormat="dd MMMM, yyyy"
      customInput={
        <div className="form-control d-flex align-items-center justify-content-between py-3 px-3 shadow-sm border-2 clickable-input" style={{ cursor: 'pointer', borderRadius: '12px' }}>
          <div className="d-flex align-items-center">
            <FaCalendarCheck className="text-primary me-3" size={20} />
            <div>
              <span className="text-muted small d-block">
                {packages?.type === "fit" ? "Flexible Departure" : "Fixed Departure"}
              </span>
              <span className={selectedDate ? "fw-bold text-dark" : "text-muted"}>
                {selectedDate ? selectedDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) : "Choose Date"}
              </span>
            </div>
          </div>
          {/* <FaChevronDown className="text-muted small" /> */}
        </div>
      }
    />
  </div>

  {/* Dynamic Helper Text */}
  <p className="text-muted mt-2 ps-1" style={{ fontSize: '0.75rem' }}>
    {packages?.type === "fit" 
      ? "* You can pick any date starting from today." 
      : "* Only specific highlighted dates are available for this group tour."}
  </p>
</div>

          <hr className="my-4" />

          {/* 3. TRAVELER INFORMATION */}
          <div className="mb-4">
            <h6 className="fw-bold mb-3 text-uppercase text-muted small">3. Traveler Information</h6>
            <Row className="g-3">
              <Col md={12}>
                <Form.Label className="small fw-bold">TRAVELER NAME</Form.Label>
                <InputGroup>
                  <InputGroup.Text className="bg-white border-end-0"><FaUser className="text-primary" /></InputGroup.Text>
                  <Form.Control className="border-start-0 ps-1" placeholder="Enter full name" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
                </InputGroup>
              </Col>
              
              <Col md={6}><Form.Label className="small fw-bold">EMAIL</Form.Label><InputGroup><InputGroup.Text className="bg-white border-end-0"><FaEnvelope className="text-primary" /></InputGroup.Text><Form.Control className="border-start-0 ps-1" placeholder="email@example.com" value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} /></InputGroup>
              
                {formErrors.email && (
                                    <Form.Text className="text-danger" style={{ fontSize: '12px' }}>{formErrors.email}</Form.Text>
                                  )}</Col>
              
              <Col md={6}><Form.Label className="small fw-bold">MOBILE</Form.Label><InputGroup><InputGroup.Text className="bg-white border-end-0"><FaPhoneAlt className="text-primary" /></InputGroup.Text><Form.Control className="border-start-0 ps-1" placeholder="10-digit number" value={formData.mobile} onChange={e => setFormData({ ...formData, mobile: e.target.value })} /></InputGroup>
                {formErrors.mobile && (
                                    <Form.Text className="text-danger" style={{ fontSize: '12px' }}>{formErrors.mobile}</Form.Text>
                                  )}
              </Col>
              
              <Col xs={6}>
                <Form.Label className="small fw-bold">ADULTS</Form.Label>
                <div className="d-flex align-items-center justify-content-between border rounded-3 p-1 bg-white shadow-sm">
                    <Button variant="link" className="text-dark p-0" onClick={() => setFormData({ ...formData, adults: Math.max(1, formData.adults - 1) })} style={{textDecoration:'none', fontSize:'20px'}}>-</Button>
                    <span className="fw-bold px-2">{formData.adults}</span>
                    <Button variant="link" className="text-dark p-0" onClick={() => setFormData({ ...formData, adults: formData.adults + 1 })} style={{textDecoration:'none', fontSize:'20px'}}>+</Button>
                </div>
              </Col>

              <Col xs={6}>
                <Form.Label className="small fw-bold">CHILDREN</Form.Label>
                <div className="d-flex align-items-center justify-content-between border rounded-3 p-1 bg-white shadow-sm">
                    <Button variant="link" className="text-dark p-0" onClick={() => setFormData({ ...formData, children: Math.max(0, formData.children - 1) })} style={{textDecoration:'none', fontSize:'20px'}}>-</Button>
                    <span className="fw-bold px-2">{formData.children}</span>
                    <Button variant="link" className="text-dark p-0" onClick={() => setFormData({ ...formData, children: formData.children + 1 })} style={{textDecoration:'none', fontSize:'20px'}}>+</Button>
                </div>
              </Col>

              <Col md={12}><Form.Label className="small fw-bold">NOTES</Form.Label><InputGroup><InputGroup.Text className="bg-white border-end-0 align-items-start pt-2"><FaStickyNote className="text-primary" /></InputGroup.Text><Form.Control className="border-start-0 ps-1" as="textarea" rows={2} placeholder="Any special requests..." value={formData.customerNotes} onChange={e => setFormData({ ...formData, customerNotes: e.target.value })} /></InputGroup></Col>
            </Row>
          </div>

          <div className="mt-4 pt-3 border-top">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <span className="text-muted small text-uppercase fw-bold">Total Estimation</span>
                <div className="h2 fw-bold text-primary mb-0"><FaRupeeSign />{calculateTotal().toLocaleString()}</div>
              </div>
            
            </div>
            <Button className="w-100 py-3 fw-bold" style={{ backgroundColor: '#0a3b78', border: 'none', borderRadius: '10px' }} onClick={handleBookingSubmit}>SUBMIT ENQUIRY <FaArrowRight className="ms-2" /></Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TourBookingCard;

